/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { FeaturePanelFragment } from "@cosmos/hygraph-schema";

import { VStack } from "@panda/jsx";

import { FeaturePanel } from "./FeaturePanel.molecule";
import { ButtonList, CosmosButtonProps } from "@components/elements";

export type FeaturePanelsProps = {
	cards?: FeaturePanelFragment[] | null;
	disableCardBg?: boolean | null;
	verticallyCenter?: boolean | null;
	buttons?: CosmosButtonProps[] | null;
};

export function FeaturePanels({
	cards = [],
	disableCardBg = false,
	verticallyCenter = false,
	buttons = [],
}: FeaturePanelsProps): React.JSX.Element {
	return (
		<VStack
			className="feature-panels"
			gap={{
				base: disableCardBg ? "eds.dimension.48" : "eds.dimension.24",
				smDown: disableCardBg ? "eds.dimension.40" : "",
			}}
		>
			{(cards || []).map((card, i) => (
				<FeaturePanel
					key={`feature-panel-${i}`}
					disableCardBg={disableCardBg}
					verticallyCenter={verticallyCenter}
					{...card}
				/>
			))}
			{buttons ? <ButtonList buttons={buttons} size="lg" /> : null}
		</VStack>
	);
}
